import React from 'react';
import { clsx } from 'clsx';
import { MdOutlineWarningAmber } from 'react-icons/md';

interface IProps {
    children: React.ReactNode;
    className?: string;
}

const MatrixWarning: React.FC<IProps> = ({ children, className }) => (
    <div className={clsx('ws2-warning', className)}>
        <MdOutlineWarningAmber className="ws2-warning__icon" size="16px" aria-hidden />
        <span className="ws2-warning__text">{children}</span>
    </div>
);

export default MatrixWarning;
